

import {
  Link,
  thc,
} from '@flightstats/airframe-react';

export const NoHrefLink = thc(
  Link,
  {},
  {
    '&:hover': {
      cursor: 'pointer',
    },
  },
);
